import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", {
      class: _normalizeClass(["fixed md:static inset-y-0 left-0 z-50 w-72 bg-white/80 backdrop-blur-xl border-r border-gray-200/60 px-5 py-6 flex flex-col gap-8 transform transition-transform duration-300 ease-out", [
            _ctx.isOpen ? 'translate-x-0' : '-translate-x-full',
            'md:translate-x-0'
        ]])
    }, [
      _createVNode(_component_RouterLink, { to: "/" }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "flex items-center gap-3 cursor-pointer group" }, [
            _createElementVNode("div", { class: "h-11 w-11 rounded-xl bg-indigo-600 text-white flex items-center justify-center text-xl font-bold shadow-md group-hover:scale-105 transition" }, " ₹ "),
            _createElementVNode("span", { class: "text-xl font-extrabold tracking-tight text-gray-900" }, [
              _createTextVNode(" Pay"),
              _createElementVNode("span", { class: "text-indigo-600" }, "Log")
            ])
          ], -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
          return (_openBlock(), _createBlock(_component_RouterLink, {
            key: item.path,
            to: item.path,
            class: _normalizeClass([_ctx.linkClass(item.path), "md:pointer-events-auto"]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FontAwesomeIcon, {
                icon: item.icon,
                class: "text-base"
              }, null, 8, ["icon"]),
              _createElementVNode("span", null, _toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128))
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-auto text-xs text-gray-400 tracking-wide" }, " PayLog • v1.0.0 ", -1))
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-40 bg-black/10 backdrop-blur-sm md:hidden transition-opacity",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }))
      : _createCommentVNode("", true)
  ], 64))
}